<bolt-modal
  #devToolsModal
  heading="Developer Tools"
  primarybutton="Be Gone"
  tertiarybutton="Log Out"
  (bolt-modal-tertiary-button-click)="logout()"
>
  <hsc-card title="E2E Testing" [active]="devToolsEmailOverride()">
    <div class="flex flex-col gap-1">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4">
          <div>Email Override:</div>
        </div>
        <div class="flex gap-2">
          <bolt-switch
            optionaltext="hide"
            [checked]="devToolsEmailOverride()"
            (change)="toggleEmailOverride()"
          ></bolt-switch>
        </div>
      </div>
    </div>
  </hsc-card>

  <hsc-card title="Integration Testing">
    <form [formGroup]="developerToolsForm" class="flex flex-col gap-1">
      <div class="flex items-center justify-between">
        <div>
          {{ apiEndpoints.pcPolicyNumber.basePath }}:
          <bolt-contextual-help>
            <p>Test retrieval of predefined policies</p>
          </bolt-contextual-help>
        </div>
        <div class="flex gap-2">
          <bolt-select class="w-[200px]" formControlName="policyNumber" ngDefaultControl>
            @for (option of policyNumberSelectOptions; track option.label) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </bolt-select>
          <bolt-button
            (click)="handlePolicyNumber()"
            (keydown)="handlePolicyNumber()"
            [disabled]="!developerToolsForm.controls.policyNumber.value || apigeeIsLoading()"
            iconleft="send"
            type="solid"
          />
        </div>
      </div>

      <div class="flex items-center justify-between">
        <div>
          {{ apiEndpoints.pcSubmissionNumber.basePath }}:
          <bolt-contextual-help>
            <p>Test retrieval of predefined submissions</p>
          </bolt-contextual-help>
        </div>
        <div class="flex gap-2">
          <bolt-select class="w-[200px]" formControlName="submissionNumber" ngDefaultControl>
            @for (option of submissionNumberSelectOptions; track option.label) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </bolt-select>
          <bolt-button
            (click)="handleSubmissionNumber()"
            (keydown)="handleSubmissionNumber()"
            [disabled]="!developerToolsForm.controls.submissionNumber.value || apigeeIsLoading()"
            iconleft="send"
            type="solid"
          />
        </div>
      </div>

      <div class="flex items-center justify-between">
        <div>
          {{ apiEndpoints.axiomQuote.basePath }}:
          <bolt-contextual-help>
            <p>Test submission of predefined quotes</p>
          </bolt-contextual-help>
        </div>
        <div class="flex gap-2">
          <bolt-select class="w-[200px]" formControlName="axiomQuote" ngDefaultControl>
            @for (option of axiomQuoteSelectOptions; track option.label) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </bolt-select>
          <bolt-button
            (click)="handleAxiomQuote()"
            (keydown)="handleAxiomQuote()"
            [disabled]="!developerToolsForm.controls.axiomQuote.value || apigeeIsLoading()"
            iconleft="send"
            type="solid"
          />
        </div>
      </div>

      <div class="flex items-center justify-between">
        <div>
          {{ apiEndpoints.axiomEmail.basePath }}:
          <bolt-contextual-help>
            <p>Test submission of emails. Populated with axiom-quote call</p>
          </bolt-contextual-help>
        </div>

        <div class="flex gap-2">
          <bolt-textfield
            class="w-[200px]"
            [value]="developerToolsForm.controls.axiomEmailAddress.value"
            ngDefaultControl
            disabled
          ></bolt-textfield>
          <bolt-button
            (click)="handleAxiomEmail()"
            (keydown)="handleAxiomEmail()"
            [disabled]="
              !developerToolsForm.controls.axiomEmailAddress.value ||
              !developerToolsForm.controls.axiomEmailQuoteId.value ||
              apigeeIsLoading()
            "
            iconleft="send"
            type="solid"
          />
        </div>
      </div>
      @if (apigeeIsLoading() || apiResponse()) {
        <div class="max-h-[250px] min-h-[40px] overflow-x-auto rounded bg-gray-100 p-2 text-xs">
          @if (apigeeIsLoading()) {
            <bolt-waiting-indicator></bolt-waiting-indicator>
          } @else {
            <pre>{{ formatApiResponse() }}</pre>
          }
        </div>
      }
    </form>
  </hsc-card>

  <!-- TODO: update disabled when we migrate to NPM package -->
  <hsc-card title="New Relic Testing" [disabled]="environment.NAME === 'local'">
    <div class="flex items-center justify-between">
      <div>Throw Client:</div>
      <div class="flex gap-2">
        <bolt-button
          (click)="handleNewRelicTesting({ target: 'client', type: 'expected' })"
          (keydown)="handleNewRelicTesting({ target: 'client', type: 'expected' })"
          [disabled]="apigeeIsLoading()"
          type="solid"
          >Expected</bolt-button
        >
        <bolt-button
          (click)="handleNewRelicTesting({ target: 'client', type: 'unhandled' })"
          (keydown)="handleNewRelicTesting({ target: 'client', type: 'unhandled' })"
          [disabled]="apigeeIsLoading()"
          type="solid"
          >Unhandled</bolt-button
        >
      </div>
    </div>
    <div class="flex items-center justify-between">
      <div>Throw Serverless:</div>
      <div class="flex gap-2">
        <bolt-button
          type="solid"
          (click)="handleNewRelicTesting({ target: 'serverless', type: 'expected' })"
          [disabled]="apigeeIsLoading()"
          (keydown)="handleNewRelicTesting({ target: 'serverless', type: 'expected' })"
          >Expected</bolt-button
        >
        <bolt-button
          (click)="handleNewRelicTesting({ target: 'serverless', type: 'unhandled' })"
          (keydown)="handleNewRelicTesting({ target: 'serverless', type: 'unhandled' })"
          [disabled]="apigeeIsLoading()"
          type="solid"
          >Unhandled</bolt-button
        >
      </div>
    </div>
  </hsc-card>

  <hsc-card title="LaunchDarkly Testing">
    <div class="flex items-center justify-between">
      <div>Trigger:</div>
      <div class="flex gap-2">
        <bolt-button
          (click)="handleLaunchDarklyTesting('identifyUser')"
          (keydown)="handleLaunchDarklyTesting('identifyUser')"
          type="solid"
        >
          Identify User</bolt-button
        >
        <bolt-button
          (click)="handleLaunchDarklyTesting('getFlagValue')"
          (keydown)="handleLaunchDarklyTesting('getFlagValue')"
          type="solid"
        >
          GetFlagValue</bolt-button
        >
      </div>
    </div>

    <details>
      <summary class="cursor-pointer">View Flag Values</summary>
      <pre class="overflow-x-auto rounded bg-gray-100 p-2 text-xs">{{ flags | async | json }}</pre>
    </details>
  </hsc-card>

  <!-- TODO: update disabled when we migrate to NPM package -->
  <hsc-card title="FullStory Testing" [disabled]="!environment.FULLSTORY_ENABLED">
    <div class="flex items-center justify-between">
      <div>Trigger:</div>
      <div class="flex gap-2">
        <bolt-button (click)="handleFullstory('setUserVars')" (keydown)="handleFullstory('setUserVars')" type="solid">
          Identify User</bolt-button
        >
        <bolt-button
          (click)="handleFullstory('getCurrentSessionUrl')"
          (keydown)="handleFullstory('getCurrentSessionUrl')"
          type="solid"
        >
          Session URL</bolt-button
        >
        <bolt-button (click)="handleFullstory('event')" (keydown)="handleFullstory('event')" type="solid">
          Event</bolt-button
        >
      </div>
    </div>
  </hsc-card>

  <hsc-card title="Splunk Testing" [disabled]="!environment.SPLUNK_ENABLED">
    <div class="flex items-center justify-between">
      <div>Trigger:</div>
      <div class="flex gap-2">
        <bolt-button (click)="handleSplunkTesting('error')" (keydown)="handleSplunkTesting('error')" type="solid">
          Error</bolt-button
        >
        <bolt-button (click)="handleSplunkTesting('warn')" (keydown)="handleSplunkTesting('warn')" type="solid">
          Warn</bolt-button
        >
        <bolt-button (click)="handleSplunkTesting('info')" (keydown)="handleSplunkTesting('info')" type="solid">
          Info</bolt-button
        >
      </div>
    </div>
  </hsc-card>

  <hsc-card title="Application Configuration">
    <pre class="overflow-x-auto rounded bg-gray-100 p-2 text-xs">{{ environment | json }}</pre>
  </hsc-card>
</bolt-modal>
